/**
 * @generated SignedSource<<ad7279eb661b43e27b461301000bbd0b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectBudgetForm_project$data = {
  readonly active: boolean;
  readonly budget_method: any;
  readonly client: {
    readonly id: number;
    readonly image_key: string | null | undefined;
    readonly internal: boolean | null | undefined;
    readonly website: string | null | undefined;
  };
  readonly emoji: string | null | undefined;
  readonly expenses_budget: number | null | undefined;
  readonly id: number;
  readonly is_template: boolean;
  readonly members: ReadonlyArray<{
    readonly id: number;
    readonly role_id: number;
  }>;
  readonly name: string;
  readonly no_phase_revenue_budget: number | null | undefined;
  readonly other_costs: ReadonlyArray<{
    readonly charge: number;
    readonly cost: number;
    readonly date: string | null | undefined;
    readonly id: number;
    readonly name: string;
    readonly phaseId: number | null | undefined;
  }>;
  readonly phases: ReadonlyArray<{
    readonly id: number;
    readonly phase_roles: ReadonlyArray<{
      readonly estimated_minutes: number | null | undefined;
      readonly id: number;
      readonly role: {
        readonly id: number;
        readonly name: string;
      };
    }>;
    readonly revenue_budget: number | null | undefined;
  }>;
  readonly pricing_model: string;
  readonly project_rates: ReadonlyArray<{
    readonly id: number;
    readonly projectId: number;
    readonly rate: number | null | undefined;
    readonly roleId: number;
  }>;
  readonly project_roles: ReadonlyArray<{
    readonly estimated_minutes: number | null | undefined;
    readonly id: number;
    readonly role_id: number;
  }>;
  readonly rate_card: {
    readonly blended_rate: number | null | undefined;
    readonly blended_rate_card: boolean;
    readonly id: number;
    readonly name: string | null | undefined;
    readonly role_charge_out_rates: ReadonlyArray<{
      readonly charge_out_rate: number | null | undefined;
      readonly rate_card_id: number;
      readonly role_id: number;
    }>;
  };
  readonly rate_type: string;
  readonly total_budget: number | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"OtherExpensesEditor_project" | "PhaseAndRoleEditor_project" | "PhaseEditor_project">;
  readonly " $fragmentType": "ProjectBudgetForm_project";
};
export type ProjectBudgetForm_project$key = {
  readonly " $data"?: ProjectBudgetForm_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectBudgetForm_project">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role_id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimated_minutes",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectBudgetForm_project",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pricing_model",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rate_type",
      "storageKey": null
    },
    {
      "alias": "total_budget",
      "args": null,
      "kind": "ScalarField",
      "name": "total_budget_private",
      "storageKey": null
    },
    {
      "alias": "no_phase_revenue_budget",
      "args": null,
      "kind": "ScalarField",
      "name": "no_phase_revenue_budget_private",
      "storageKey": null
    },
    {
      "alias": "expenses_budget",
      "args": null,
      "kind": "ScalarField",
      "name": "expenses_budget_private",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emoji",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "is_template",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "budget_method",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "project_rates",
      "kind": "LinkedField",
      "name": "project_rates",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": "projectId",
          "args": null,
          "kind": "ScalarField",
          "name": "project_id",
          "storageKey": null
        },
        {
          "alias": "roleId",
          "args": null,
          "kind": "ScalarField",
          "name": "role_id",
          "storageKey": null
        },
        {
          "alias": "rate",
          "args": null,
          "kind": "ScalarField",
          "name": "rate_private",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "rate_cards",
      "kind": "LinkedField",
      "name": "rate_card",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": "blended_rate",
          "args": null,
          "kind": "ScalarField",
          "name": "blended_rate_private",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "blended_rate_card",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "role_charge_out_rates",
          "kind": "LinkedField",
          "name": "role_charge_out_rates",
          "plural": true,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rate_card_id",
              "storageKey": null
            },
            {
              "alias": "charge_out_rate",
              "args": null,
              "kind": "ScalarField",
              "name": "charge_out_rate_private",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "project_roles",
      "kind": "LinkedField",
      "name": "project_roles",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "project_members",
      "kind": "LinkedField",
      "name": "members",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "clients",
      "kind": "LinkedField",
      "name": "client",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "internal",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "image_key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "website",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "order_by",
          "value": {
            "date": "asc"
          }
        }
      ],
      "concreteType": "other_costs",
      "kind": "LinkedField",
      "name": "other_costs",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": "date",
          "args": null,
          "kind": "ScalarField",
          "name": "date_runn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cost",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "charge",
          "storageKey": null
        },
        {
          "alias": "phaseId",
          "args": null,
          "kind": "ScalarField",
          "name": "phase_id",
          "storageKey": null
        }
      ],
      "storageKey": "other_costs(order_by:{\"date\":\"asc\"})"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "phases",
      "kind": "LinkedField",
      "name": "phases",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": "revenue_budget",
          "args": null,
          "kind": "ScalarField",
          "name": "revenue_budget_private",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "phase_roles",
          "kind": "LinkedField",
          "name": "phase_roles",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "roles",
              "kind": "LinkedField",
              "name": "role",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/)
              ],
              "storageKey": null
            },
            (v3/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PhaseEditor_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PhaseAndRoleEditor_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OtherExpensesEditor_project"
    }
  ],
  "type": "projects",
  "abstractKey": null
};
})();

(node as any).hash = "9f2b75f13ef38c6bafcdda3dc667bd21";

export default node;
